import { render, staticRenderFns } from "./proReviewHistory.vue?vue&type=template&id=d59ade3e&scoped=true&"
import script from "./proReviewHistory.vue?vue&type=script&lang=js&"
export * from "./proReviewHistory.vue?vue&type=script&lang=js&"
import style0 from "./proReviewHistory.vue?vue&type=style&index=0&id=d59ade3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59ade3e",
  null
  
)

export default component.exports